import React, { useState, useCallback, useContext, useEffect } from 'react'
import { getMarginAnalysisScnerio } from 'api/pgads'
import { ErrorContext } from 'context'
import { freeEditEngine } from '@integec/grid-tools'
import JcTmpErrorDialog from 'core/component/JcTmpErrorDialog'

import R from 'ramda'

const MarginAnalysisContext = React.createContext(null)

export const MarginAnalysisProvider = ({ children, loadDateData }) => {
  const [unitSelection, setUnitSelection] = useState([])

  const [retrievedData, setRetrievedData] = useState({})
  const [eventPlanningData, setEventPlanningData] = useState({})

  const [WFRetrieveData, setWFRetrievedData] = useState({ isNew: false })
  // its use for edit event popup
  const [WFSelectedEvent, setWFSelectedEvents] = useState()

  const [scenarioList, setScenarioList] = useState([])
  const [selectedScenario, setSelectedScenario] = useState({})

  const [showMaxEco, setShowMaxEco] = useState(true)
  const [showMinEco, setShowMinEco] = useState(true)
  const [showTarget, setShowTarget] = useState(true)
  const [showGenMW, setShowGenMW] = useState(true)
  const [scrollValueLeft, setScrollValueLeft] = useState(0)

  const [eventDataEditInfo, setEventDataEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )

  const [priceDataEditInfo, setPriceDataEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )

  const [costDataEditInfo, setCostDataEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )

  const [lostType, setLostType] = useState(1)

  const clearEventDataEditInfo = _ => {
    setEventDataEditInfo(freeEditEngine.generateInitialEditInfo())
    setPriceDataEditInfo(freeEditEngine.generateInitialEditInfo())
    setCostDataEditInfo(freeEditEngine.generateInitialEditInfo())
  }

  const { setError, error } = useContext(ErrorContext)

  const reloadScenario = useCallback(
    (targetInfo, setData) => {
      getMarginAnalysisScnerio(targetInfo).fork(
        err => {
          if (!R.equals(error, err)) setError(err)
        },
        data => {
          setScenarioList(data)
          setData && setData(data)
        }
      )
    },
    [error, setError]
  )

  const [jcErrors, setJcError] = useState([])

  // useEffect(
  //   _ => {
  //     setJcError(retrievedData.errors || [])
  //   },
  //   [retrievedData]
  // )

  const handleWFRetrieveData = (data, dialogCloseFunc) => {
    const { errors = [] } = data
    if (errors.find(e => e.severity === 1 || e.severity === '1')) {
      setJcError(errors)
      // setWFRetrievedData(data)
    } else {
      // warning
      if (errors.length > 0) setJcError(errors)

      setWFRetrievedData(data)
      clearEventDataEditInfo()
      dialogCloseFunc && dialogCloseFunc()
    }
  }

  const handlerRetrieveData = (
    data,
    dialogCloseFunc,
    isEventPlanning = false
  ) => {
    const { errors = [] } = data
    if (errors.find(e => e.severity === 1 || e.severity === '1')) {
      setJcError(errors)
    } else {
      // warning
      if (errors.length > 0) setJcError(errors)
      if (isEventPlanning) setEventPlanningData(data)
      else setRetrievedData(data)
      // clearEventDataEditInfo()
      dialogCloseFunc && dialogCloseFunc()
    }
  }

  const removeEventData = _ => {
    const { eventnum } = WFSelectedEvent
    const { events } = WFRetrieveData
    const otherEvents = events.filter(f => f.eventnum !== eventnum)
    clearEventDataEditInfo()
    setWFSelectedEvents({})

    setWFRetrievedData({ ...WFRetrieveData, events: otherEvents })
  }

  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([])

  useEffect(
    _ => {
      if (selectedDateRangePicker[0])
        loadDateData(
          selectedDateRangePicker[0],
          selectedDateRangePicker[1],
          false
        )
    },
    [loadDateData, selectedDateRangePicker]
  )

  // useEffect(
  //   _ => {
  //     setWFRetrievedData({})
  //     setRetrievedData({})
  //     clearEventDataEditInfo()
  //     setSelectedScenario({})
  //     // if (selectedDateRangePicker[0])
  //     // datePickerContext.setSelectedDateRagePicker(selectedDateRangePicker)
  //   },
  //   [selectedDateRangePicker]
  //   // [datePickerContext, selectedDateRangePicker, setSelectedDateRagePicker]
  // )

  const onMenuChnageCall = _ => {
    // setWFRetrievedData({})
    // setRetrievedData({})
    // clearEventDataEditInfo()
    //  setSelectedScenario({})
    // setWFSelectedEvents({})
    // setScrollValueLeft(0)
    // setScenarioList([])
  }

  return (
    <MarginAnalysisContext.Provider
      value={{
        unitSelection,
        setUnitSelection,
        onMenuChnageCall,
        WFRetrieveData,
        setWFRetrievedData,

        handleWFRetrieveData,
        handlerRetrieveData,

        removeEventData,

        WFSelectedEvent,
        setWFSelectedEvents,

        retrievedData,
        setRetrievedData,

        scenarioList,
        setScenarioList,

        selectedScenario,
        setSelectedScenario,

        showMaxEco,
        setShowMaxEco,
        showMinEco,
        setShowMinEco,
        showTarget,
        setShowTarget,
        showGenMW,
        setShowGenMW,
        scrollValueLeft,
        setScrollValueLeft,
        reloadScenario,

        priceDataEditInfo,
        setPriceDataEditInfo,

        eventDataEditInfo,
        setEventDataEditInfo,

        costDataEditInfo,
        setCostDataEditInfo,

        clearEventDataEditInfo,
        selectedDateRangePicker,
        setSelectedDateRagePicker,

        lostType,
        setLostType,

        eventPlanningData,
        setEventPlanningData,
      }}
    >
      {(jcErrors || []).length > 0 && (
        <JcTmpErrorDialog
          errors={jcErrors}
          visible={jcErrors.length > 0}
          closeErrorPrompt={_ => setJcError([])}
        />
      )}
      {children}
    </MarginAnalysisContext.Provider>
  )
}

export default MarginAnalysisContext
